export enum CertificateRenewalState {
  ALL = -1,
  PENDING,
  REQUESTED,
  CANCELLED
}
